import { Alert, Box, Button, Stack, Typography } from '@mui/joy';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { rootRouteId, useMatch, useRouter } from '@tanstack/react-router';

import CrossIcon from '@/assets/icons/cross.svg?react';
import { ObfuscatedEmail } from '@/components/legal/ObfuscatedEmail';
import { ErrorRoot } from '@/components/router/ErrorContainer';
import { RouterLink } from '@/components/router/RouterLink';

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter();
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  });

  // eslint-disable-next-line no-console
  console.error('DefaultCatchBoundary', error);

  return (
    <ErrorRoot>
      <Alert
        color="danger"
        startDecorator={<CrossIcon style={{ width: 40, height: 'auto', marginRight: 32 }} />}
        sx={{ flex: 1, paddingX: 4 }}
        variant="soft"
        endDecorator={
          <Stack direction="row" gap={4}>
            {isRoot ? (
              <RouterLink color="danger" to="/">
                Startseite
              </RouterLink>
            ) : (
              <RouterLink
                color="danger"
                to="/"
                onClick={(event) => {
                  event.preventDefault();
                  window.history.back();
                }}
              >
                Zu Startseite
              </RouterLink>
            )}

            <Button
              color="danger"
              onClick={() => {
                router.invalidate();
              }}
            >
              Erneut versuchen
            </Button>
          </Stack>
        }
      >
        <Box>
          <Typography component="h1" level="h2">
            Fehler
          </Typography>

          <Typography mb={2}>
            Sollte das Problem wiederholt auftreten kontaktieren Sie <ObfuscatedEmail name="radmelder" />.
          </Typography>
          <Typography>{error.message}</Typography>
        </Box>
      </Alert>
    </ErrorRoot>
  );
}
